import Vue from "vue";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StaffService from "@/service/StaffService";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import StoreGetter from "@/constants/StoreGetter";
import { PayProfile } from "@/model/PayProfile";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Setting from "@/constants/Settings";
import PayProfileService from "@/service/PayProfileService";
import CompanyService from "@/service/CompanyService";
import PayTypeService from "@/service/PayTypeService";
import PayGroupService from "@/service/PayGroupService";
import payProfileValidation from "./106000-PayProfileValidation.js";
import Paginate from "vuejs-paginate";
import moment from "moment";
import { GlobalMixin } from "@/common/mixin/GlobalMixin";
var payProfileObj = new payProfileValidation();
export default {
  name: "payProfile",
  mounted() {
    payProfileObj.payProfileValidation();
    this.assignRights();
    this.getAllPayProfile();
    this.getDeptList();
    this.getCompList();
    this.getStaffList();
    this.getPayGroupList();
    this.getPayTypeList();
  },
  components: {
    paginate: Paginate
  },
  data: () => ({
    ...GlobalMixin,
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Setting.MenuID.PayProfile,
    dictEnum: dictEnum,
    payProfile: new PayProfile(),
    isEditMode: false,
    payProfileList: [],
    selectAllPayProfile: false,
    selectedPayProfileModel: new PayProfile(),
    compList: [],
    deptList: [],
    payGrpList: [],
    payTypeList: [],
    staffList: [],
    search: {
      Company: "",
      Dept: "",
      PayGroup: "",
      PayType: ""
    },
    currentPage: 1,
    perPage: 15,
    fields: [
      {
        key: "CompCode",
        label: t.t(dictEnum.LBL_Company),
        thStyle: { width: "15%" }
      },
      {
        key: "StaffID",
        label: t.t(dictEnum.LBL_StaffID),
        thStyle: { width: "10%" }
      },
      {
        key: "Name",
        label: t.t(dictEnum.LBL_Name),
        thStyle: { width: "10%" }
      },
      {
        key: "JobTitle",
        label: t.t(dictEnum.LBL_JobTitle),
        thStyle: { width: "10%" }
      },
      {
        key: "EmpType",
        label: t.t(dictEnum.LBL_EmpType),
        thStyle: { width: "5%" }
      },
      {
        key: "JoinDate",
        label: t.t(dictEnum.LBL_DateJoin),
        thStyle: { width: "5%" }
      },
      {
        key: "YOS",
        label: t.t(dictEnum.LBL_YOS),
        thStyle: { width: "5%" }
      },
      {
        key: "PayGrpCode",
        label: t.t(dictEnum.LBL_PayGroup),
        thStyle: { width: "10%" }
      },
      {
        key: "PayRate",
        label: t.t(dictEnum.LBL_Rate),
        thStyle: { width: "10%" }
      },
      {
        key: "VCR",
        label: t.t(dictEnum.LBL_VCR),
        thStyle: { width: "10%" }
      },
      {
        key: "VCE",
        label: t.t(dictEnum.LBL_VCE),
        thStyle: { width: "10%" }
      },
      {
        key: "Action",
        label: "",
        thStyle: { width: "5%" }
      }
    ]
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    }
  },
  methods: {
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },

    formatVC(e) {
      return String(e).substring(0, 3);
    },

    formatAmt(e) {
      return String(e).substring(0, 8);
    },

    async getPerPage() {
      const tableEle = await document.getElementsByClassName("tableHg");
      const trEle = await document.getElementsByTagName("tr");
      const tableHeight = tableEle[0].offsetHeight;
      if (trEle.length > 1) {
        const thHeight = trEle[0].offsetHeight;
        const tdHeight = trEle[1].offsetHeight;
        let page = (tableHeight - thHeight) / (tdHeight + 2);
        this.perPage = page.toFixed(0);
      }
    },

    PayGrpName(PayGrpCode) {
      const grp = this.payGrpList.find(x => x.Grp == PayGrpCode);
      if (grp) {
        return grp.GrpDesc;
      } else {
        return "";
      }
    },

    compName(comp) {
      const find = this.compList.find(x => x.CompCode == comp);
      if (find) {
        return this.user.Lang == "EN" ? find.EName : find.CName;
      }
    },

    async getCompList() {
      var obj = {
        take: 100,
        skip: 0
      };
      const response = await CompanyService.getAllCompanyList(obj);
      if (response.data.IsSuccess) {
        this.compList = response.data.Data.Item1;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getDeptList() {
      var obj = {};
      const response = await StaffEmploymentService.getAllDepartment(obj);
      if (response.data.IsSuccess) {
        this.deptList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getPayGroupList() {
      var obj = {};
      const response = await PayGroupService.getAllPayGroup(obj);
      if (response.data.IsSuccess) {
        this.payGrpList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getPayTypeList() {
      var obj = {};
      const response = await PayTypeService.getAllPayType(obj);
      if (response.data.IsSuccess) {
        this.payTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getStaffList() {
      var obj = {
        staffID: ""
      };
      const response = await StaffService.getAllStaff(obj);
      if (response.data.IsSuccess) {
        this.staffList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getAllPayProfile() {
      var obj = this.search;
      const response = await PayProfileService.getAllPayProfile(obj);
      if (response.data.IsSuccess) {
        this.payProfileList = response.data.Data;
        this.getPerPage();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    selectAllPayProfileRecord: function() {
      var IsSelected = this.selectAllPayProfile;
      this.payProfileList.forEach(function(val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    deleteMultiplePayProfilePopup: function() {
      var arrayList = [];
      this.payProfileList.forEach(function(key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $("#deletePayProfileListModel").modal("show");
      } else {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.MSG_SelectDeleteRecord)
        );
      }
    },
    async deleteMultiplePayProfile() {
      var arrayList = [];
      $("#deletePayProfileListModel").modal("hide");
      this.payProfileList.forEach(function(key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      const obj = {
        assessTempList: arrayList
      };
      const response = await PayProfileService.deletePayProfile(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        this.resetPayProfile();
        await this.getAllPayProfile();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (this.selectedPayProfileModel.StaffID == item.StaffID) {
        return "selected-tr";
      }
    },
    OnPayProfileSelect: function(model) {
      this.selectedPayProfileModel = model;
    },
    addPayProfile: function() {
      $("#payProfileModel").modal("show");
      this.isEditMode = false;
      this.payProfile = new PayProfile();
      this.$validator.reset();
      this.vErrors.clear();
    },
    async updatePayProfile(obj) {
      const response = await PayProfileService.updatePayProfile(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        this.resetPayProfile();
        await this.getAllPayProfile();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    changePayGrp() {
      const find = this.payGrpList.find(
        x => x.Grp == this.payProfile.PayGrpCode
      );
      if (find) {
        this.payProfile.PayTypeCode = find.PayTypeCode;
      }
    },
    async savePayProfile() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          $("#payProfileModel").modal("hide");
          this.changePayGrp();
          const obj = {
            model: {
              StaffID: self.payProfile.StaffID,
              PayTypeCode: self.payProfile.PayTypeCode,
              PayRate: self.payProfile.PayRate,
              PayGrpCode: self.payProfile.PayGrpCode,
              VCR: self.payProfile.VCR,
              VCE: self.payProfile.VCE,
              DateAdd: self.payProfile.DateAdd,
              AddBy: self.payProfile.AddBy,
              DateModify: moment().format(Setting.DateTime.DateTime),
              ModifyBy: this.user.UserID,
              RecDel: false
            }
          };
          if (self.isEditMode) {
            self.updatePayProfile(obj);
          }
        }
      });
    },
    async editPayProfileDetail() {
      this.isEditMode = true;
      if (this.selectedPayProfileModel.StaffID != "") {
        this.payProfile = JSON.parse(
          JSON.stringify(this.selectedPayProfileModel)
        );
        this.$validator.reset();
        this.vErrors.clear();
        $("#payProfileModel").modal("show");
      } else {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.MSG_SelectEditRecord)
        );
      }
    },
    resetPayProfile: function() {
      this.selectAllPayProfile = false;
      this.isEditMode = false;
      this.payProfile = new PayProfile();
      this.selectedPayProfileModel = new PayProfile();
      this.$validator.reset();
      this.vErrors.clear();
    },
    closePayProfilePopup: function() {
      this.selectAllPayProfile = false;
      this.isEditMode = false;
      this.payProfile = new PayProfile();
      this.selectedPayProfileModel = new PayProfile();
      this.$validator.reset();
      this.vErrors.clear();
      $("#payProfileModel").modal("hide");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/100000-Payroll/106000-PayProfile/106000-PayProfile.js